import { UserMultiple } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Пациенты клиники (СКР-02, АДМ-33; матрица 2.2 «Карточки пациентов»: FRONT_DESK — изменение всех, DOCTOR — свои,
 * OWNER, MED_DIR, OPS_DIR — чтение).
 */
export const section = defineSection({
  id: 'schedule.patients',
  area: 'clinic',
  path: 'patients/*',
  roles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'DOCTOR', 'FRONT_DESK'],
  icon: UserMultiple,
  titleKey: 'patients:title',
  namespaces: ['portal'],
  navGroup: 'work',
  order: 60,
  navRoles: ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'FRONT_DESK'],
  load: () => import('./PatientsPage'),
});
